export const SHADOW_RESOLUTION = 1024;
export const SHADOW_BLEND = 101;
// Every model uses the same repeatable light-sampling sequence. Geometry still
// changes the light rig's size and position, but never the source of entropy.
export const SHADOW_LIGHT_SAMPLE_SEED = 0x8f3d2a71;
export const PROGRESSIVE_SHADOW_BLEND = 23;
export const PROGRESSIVE_SHADOW_INITIAL_DELAY_MS = 250;
export const PROGRESSIVE_SHADOW_MAP_SIZE = 512;
export const SHADOW_BAKE_ACTIVE_USER_DATA_KEY = (
    'modelViewerShadowBakeActive'
);

// Drei exposes the second target in its progressive light-map ping-pong pair.
// An even update count leaves that target populated and exposed after every bake.
export const SHADOW_UPDATES = SHADOW_BLEND + 1;
export const PROGRESSIVE_SHADOW_UPDATES = PROGRESSIVE_SHADOW_BLEND + 1;

export const PROGRESSIVE_SHADOW_DELAY_MS = 75;
export const SHADOW_ALPHA_TEST = 0.2;
export const SHADOW_COLOR_BLEND = 2;
export const SHADOW_OPACITY = 0.5;
